<template>
  <div class="pageHeader">
    <div
      class="HomeContainer"
      style="display: flex; justify-content: space-between"
    >
      <div class="leftContainer">
        <div>{{ l("欢迎来到中锻材") }}！</div>

        <template v-if="$store.state.session.token">
          <el-dropdown @command="handlePersonalCommand">
            <span style="cursor: pointer; font-size: 12px">
              {{ $store.state.session.user.display_name
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="setting">{{
                l("个人设置")
              }}</el-dropdown-item>
              <el-dropdown-item
                v-if="$store.state.session.host_token"
                key="logout_host"
                divided
                command="logout_host"
                >{{ l("返回后管账号") }}</el-dropdown-item
              >
              <el-dropdown-item divided command="logout">{{
                l("退出登录")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

        <template v-else>
          <div class="btn" @click="$store.commit('logout')">
            {{ l("请登录") }}
          </div>
          <router-link class="btn" to="/register">{{
            l("免费注册")
          }}</router-link>
        </template>
      </div>
      <div class="rightContainer">
        <router-link class="link" to="/"> {{ l("中锻材首页") }} </router-link>
        <div class="split"></div>
        <template v-if="$store.state.session.token">
          <router-link class="link" to="/backend">{{
            l("个人中心")
          }}</router-link>
          <div class="split"></div>
        </template>
        <template v-if="$store.state.session.user.is_backend">
          <router-link class="link" to="/admin">{{
            l("后管系统")
          }}</router-link>
          <div class="split"></div>
        </template>
        <router-link class="link" to="/home/help">{{
          l("帮助中心")
        }}</router-link>
        <div class="split"></div>
        <div>{{ l("服务热线") }}：400-617-3617</div>
      </div>
    </div>

    <PersonalInfo
      ref="PersonalInfo"
      @submitDialog="$store.dispatch('updateSession')"
    />
  </div>
</template>

<script>
import PersonalInfo from "@/views/account/PersonalInfo.vue";

export default {
  name: "PageHeader",
  components: {
    PersonalInfo,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handlePersonalCommand(command) {
      if (command == "setting") {
        this.$refs.PersonalInfo.Type = "Edit";
        this.$refs.PersonalInfo.Show();
      } else if (command == "logout") {
        this.$store.commit("logout");
      } else if (command == "logout_host") {
        this.$localStorage.set("token", this.$store.state.session.host_token);
        this.$store.setSession("token", this.$store.state.session.host_token);

        this.$localStorage.remove("host_token");
        this.$store.setSession("host_token", null);

        setTimeout(() => {
          //保证在finally之后执行
          this.$store.dispatch("updateSession").then(() => {
            this.$store.commit("updateUnreadNotify");
            this.$router.push({ path: "/admin/dashboard" });
          });
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pageHeader {
  // background: #F1F1F1 ;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
  color: $themeColor;
  height: $topHeight;
  font-size: 12px;

  .leftContainer {
    height: $topHeight;
    display: flex;
    align-items: center;
    .btn {
      cursor: pointer;
      margin-left: 10px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .rightContainer {
    height: $topHeight;
    display: flex;
    align-items: center;
    .link {
      cursor: pointer;
    }
    .split {
      width: 1px;
      height: $topHeight / 3;
      background: #999;
      margin: 0 12px;
    }
  }
}
// a标签(router-link样式)
a {
  color: $themeColor;
}
</style>
